import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { hasSVG } from '../../../fc-core/src/lib';
var FC_TOOLTIP_CLASS = 'fc__tooltip',
    GUTTER_12 = 12;

var UNDEF,
    _getContainerBounds = function _getContainerBounds(a) {
  var b = a.getBoundingClientRect();
  return {
    left: 0,
    top: 0,
    right: b.width,
    bottom: b.height
  };
};

var ToolTip =
/*#__PURE__*/
function () {
  function ToolTip(a, b) {
    _classCallCheck(this, ToolTip);

    var c = this;
    c.text = '', c.x = 0, c.y = 0, c.visibleWidth = 0, c.universe = a, c.setUniverseBounds(b || _getContainerBounds(a)), c.data = {
      active: !1,
      target: !1
    }, c.element = c.createElement(a);
  }

  _createClass(ToolTip, [{
    key: "setUniverseBounds",
    value: function setUniverseBounds(a) {
      this.universeBounds = a || this.universe && _getContainerBounds(this.universe);
    }
  }, {
    key: "createElement",
    value: function createElement(a) {
      var b = document.createElement('div');
      return b.setAttribute('class', FC_TOOLTIP_CLASS), b.className += ' fusioncharts-div', b.innerHTML = this.text, b.style.color = '#545454', b.style.padding = '3px', b.style.fontSize = '10px', b.style.overflow = 'hidden', b.style.borderWidth = '1px', b.style.borderColor = '#000000', b.style.whiteSpace = 'nowrap', b.style.position = 'absolute', b.style.borderStyle = 'solid', b.style.backgroundColor = '#ffffff', b.style['user-select'] = 'none', b.style['-ms-user-select'] = 'none', b.style['-moz-user-select'] = 'none', b.style['-webkit-user-select'] = 'none', b.style['-webkit-touch-callout'] = 'none', b.style.top = this.x + 'px', b.style.left = this.y + 'px', b.style.visibility = 'hidden', b.style['pointer-events'] = 'none', a.appendChild(b), b;
    }
  }, {
    key: "setData",
    value: function setData(a, b) {
      this.data[a] = b;
    }
  }, {
    key: "getData",
    value: function getData(a) {
      return this.data[a];
    }
  }, {
    key: "setStyle",
    value: function setStyle(a) {
      var b = this.element,
          c = b.style;
      c.color = a.fontColor, hasSVG ? (c.backgroundColor = a.bgColor, c.borderColor = a.borderColor, c.boxShadow = a.showToolTipShadow ? '1px 1px 3px rgba(64,64,64,0.4)' : 'none') : (c.backgroundColor = a.rawBgColor, c.borderColor = a.rawBorderColor), c.fontFamily = a['font-family'], c.fontSize = a['font-size'] + 'px', c.borderWidth = a.borderThickness + 'px', c.borderRadius = a.borderRadius + 'px', c.padding = a.padding + 'px';
    }
  }, {
    key: "show",
    value: function show(a) {
      this.text !== a && (this.text = a, this.element.innerHTML = this.text), this.setData('active', !0), 'visible' !== this.element.style.visibility && (this.element.style.visibility = 'visible'), this.element.style['will-change'] = 'left, top', this.element.style['max-width'] = this.universeBounds.right - this.universeBounds.left - 24 + 'px';
    }
  }, {
    key: "update",
    value: function update() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.x;
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.y;
      var c = this.universeBounds,
          d = c.right,
          e = c.left + GUTTER_12,
          f = c.bottom - GUTTER_12,
          g = this.universeBounds.right - this.universeBounds.left - 24,
          h = this.element,
          i = h.offsetWidth,
          j = h.offsetHeight,
          k = h.style;
      a + i < d ? (k.left = a + 'px', k.whiteSpace = 'nowrap') : i < g ? k.left = a - i - GUTTER_12 + 'px' : (k.left = e + 'px', k.whiteSpace = 'normal'), k.top = b + j < f ? b + 'px' : f - j + 'px';
    }
  }, {
    key: "hide",
    value: function hide() {
      this.y = 0, this.x = 0, this.x = '', this.setData('active', !1), this.setData('target', !1), this.element.style.visibility = 'hidden', this.element.style['will-change'] = 'auto', this.element.innerHTML = '', this.text = UNDEF;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.hide(), this.universe.removeChild(this.element), this.universe = void 0, this.disposed = !0;
    }
  }]);

  return ToolTip;
}();

export default ToolTip;